function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  max-width: 200px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Empty, Select, Divider, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { formToScenarioParams } from './_helpers';
var {
  Option
} = Select;
var index = 0;

function ScenarioName(_ref) {
  var {
    form,
    isAdmin,
    endpointId,
    scenarios,
    onSelect,
    className,
    initialName
  } = _ref;
  var [items, setItems] = useState([]);
  var [name, setName] = useState(initialName);
  useEffect(() => {
    var options = scenarios.map(scenario => {
      var {
        name
      } = scenario;
      return {
        label: name,
        value: scenario
      };
    });
    setItems(options);
  }, [scenarios]);
  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  var onNameChange = e => {
    setName(e.target.value);
  };

  var addItem = () => {
    var currentFormValues = form.getFieldsValue();
    var newName = name || "New Scenario ".concat(index++);
    var newScenario = {
      endpointId,
      name: newName,
      description: '',
      category: 'current',
      functionId: 12,
      type: 'basic',
      likes: 1,
      parameters: formToScenarioParams(currentFormValues)
    };
    setItems([...items, {
      label: newName,
      value: newScenario
    }]);
    setName('');
  };

  return /*#__PURE__*/React.createElement(Select, {
    style: {
      width: '100%'
    },
    className: className,
    bordered: false,
    placeholder: "Choose scenario...",
    onSelect: onSelect,
    notFoundContent: /*#__PURE__*/React.createElement(Empty, {
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      description: "No scenarios found."
    }),
    dropdownRender: menu => /*#__PURE__*/React.createElement("div", null, menu, /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: '4px 0'
      }
    }), isAdmin && /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexWrap: 'nowrap',
        padding: 8
      }
    }, /*#__PURE__*/React.createElement(Input, {
      style: {
        flex: 'auto'
      },
      value: name,
      onChange: onNameChange
    }), /*#__PURE__*/React.createElement("a", {
      style: {
        flex: 'none',
        padding: '8px',
        display: 'block',
        cursor: 'pointer'
      },
      onClick: addItem
    }, /*#__PURE__*/React.createElement(PlusOutlined, null), " Add item")))
  }, items.map((_ref2) => {
    var {
      label,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement(Option, {
      key: label,
      value: JSON.stringify(value)
    }, label);
  }));
}

export var StyledScenarioName = styled(ScenarioName)(_templateObject());
export default ScenarioName;